<script setup>
const rule = useRobotsRule();
rule.value = "noindex, nofollow";

import { Notification } from "@arco-design/web-vue";

const router = useRouter();

const form = ref({
  username: "",
  password: "",
  password2: "",
  schoolName: "",
});

const user = useState("user");

const { handleSubmit } = useSubmit("/api/auth/signup", "/app", {
  afterSubmit: (id, res) => {
    user.value = res.user;
    router.push("/app");
  },
});

const doSubmit = async () => {
  if (!form.value.schoolName) {
    Notification.warning({
      title: "请输入学校全称",
    });
    return;
  }
  if (form.value.password !== form.value.password2) {
    Notification.warning({
      title: "两次密码输入不一致，请重新输入",
    });
    return;
  }
  await handleSubmit(form.value);
};
</script>

<template lang="pug">
WebLayout
  WebSectionTitle 赛队注册
  AppContainer(slim)
    a-card
      .underline.decoration-4.decoration-primary-400.text-2xl.mb-8 赛队注册
      a-form(@submit.prevent="doSubmit")
        FormLabel(label="用户名")
          a-input.w-full(v-model="form.username")
        FormLabel(label="密码")
          a-input-password.w-full(v-model="form.password")
        FormLabel(label="重新输入密码")
          a-input-password.w-full(v-model="form.password2")
        FormLabel(label="学校全称")
          a-input.w-full(v-model="form.schoolName", placeholder="请输入学校全称")
        WebEmpty
          p 请妥善保管您的赛队账号和密码，整个比赛过程中都需要使用此账号。请勿遗失，请勿冒用。
        a-button.w-full(size="large", type="primary", @click="doSubmit") 登录
</template>
